/**
 * The Inbox's keys (ADR 0072): what they do, for the ? sheet and the button hints, and when they
 * may act. A key acts only on the item whose panel is on screen, never while another dialog, menu
 * or list owns the keyboard (a confirm, the bulk dialogs, the session drawer stacked on top), and
 * never within KEY_SETTLE_MS of the panel's item changing.
 */
import type { ShortcutHelp } from '../../lib/shortcuts.ts';

/** An answer key this soon after the open item changed is ignored (it was meant for the one before). */
export const KEY_SETTLE_MS = 500;

/** The Inbox's own narrow-screen drawer: it does not count as another overlay. */
export const INBOX_DRAWER = 'inbox-drawer';

/** Another overlay owns the keyboard: a menu, a list, a confirm, or any dialog but the Inbox's own drawer. */
export function otherOverlayOpen(): boolean {
  if (typeof document === 'undefined') return false;
  return [...document.querySelectorAll('[role="menu"][data-state="open"], [role="listbox"][data-state="open"], [role="alertdialog"][data-state="open"], [role="dialog"][data-state="open"]')].some(
    (el) => !el.classList.contains(INBOX_DRAWER),
  );
}

/** The Inbox's keys, as the ? sheet lists them. */
export const INBOX_SHORTCUTS: ShortcutHelp[] = [
  { keys: ['j'], label: 'Next item', group: 'Actions' },
  { keys: ['k'], label: 'Previous item', group: 'Actions' },
  { keys: ['x'], label: 'Select the open item', group: 'Actions' },
  { keys: ['a'], label: 'Allow once (high risk confirms)', group: 'Actions' },
  { keys: ['s'], label: 'Allow for session, with its pattern', group: 'Actions' },
  { keys: ['r'], label: 'Make it a rule', group: 'Actions' },
  { keys: ['d'], label: 'Deny, with an optional note', group: 'Actions' },
  { keys: ['1'], label: 'Pick an option (1 to 9)', group: 'Actions' },
  { keys: ['mod', 'enter'], label: 'Send the answer to a question', group: 'Actions' },
  { keys: ['esc'], label: 'Close a form, or clear the selection', group: 'Actions' },
];
